import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, input, Output } from '@angular/core';
import '@maersk-global/mds-components-core/mc-file-upload';
import { FileUploadComponent } from '../../../shared-components/aems-file-upload/file-upload.component';
import { FormGroup } from '@angular/forms';
import { AttachmentForm } from '../../../form-model/attachment.form.model';
import { AemsFile } from '../../../models/aems-file.model';
import { InspectionDetail, InspectionDetailsWithLine } from '../../../models/inpection-detail.model';

@Component({
  selector: 'app-cwo-attachments',
  imports: [FileUploadComponent],
  templateUrl: './cwo-attachments.component.html',
  styleUrl: './cwo-attachments.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CreateWorkOrderAttachmentsComponent {
  @Input({ required: true }) attachmentForm!: FormGroup<AttachmentForm>;
  @Input() files!: AemsFile[];
  @Input() equipmentNumber!: string;
  inspectionDetails = input.required<InspectionDetail[]>();
  isEditMode = input.required<boolean>();
  shopCode = input.required<string>();
  workOrderMode = input<string>('');
  inspectionDetailsUpdatedvalue: InspectionDetail[] = [];
  @Output() inspectionImageDelete = new EventEmitter<InspectionDetail[]>();

  ngOnInit() {
    this.inspectionDetailsUpdatedvalue = this.inspectionDetails();
  }

  get inspectionDetailsForUpload(): InspectionDetailsWithLine {
    return {
      inspectionDetails: this.inspectionDetailsUpdatedvalue,
      attachReport: true,
      lineDetail: undefined,
      isEditMode: this.isEditMode(),
      equipmentNumber: this.equipmentNumber,
    };
  }

  onInspectionImageDelete(event: InspectionDetailsWithLine) {
    this.inspectionDetailsUpdatedvalue = event.inspectionDetails;
    this.inspectionImageDelete.emit(event.inspectionDetails);
  }
}
